import { FirebaseAnalytics } from '@capacitor-firebase/analytics'
import { useUserStore } from '~~/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const userStore = useUserStore()
    const currentUser = await userStore.getCurrentUser()

    // Ensure the tenant config (incl. allowPublicAccess) is resolved before we
    // decide whether to redirect — the plugin and this middleware share the same
    // in-flight load, so this can't race the async tenant fetch.
    await ensureTenantLoaded()

    // 'public' routes are always open. 'public-gallery' routes (camera-roll
    // list + detail) are open to unauthenticated visitors only when the current
    // tenant opted in via allowPublicAccess — view-only public galleries.
    const isPublic = to.meta.accesscontrol === 'public'
    const isPublicGallery =
      to.meta.accesscontrol === 'public-gallery' && useTenant().value.allowPublicAccess
    const allowThrough = isPublic || isPublicGallery

    if (!currentUser && !allowThrough) {
      console.debug('auth-triggers: User not logged in, redirecting to /login')
      return navigateTo('/start')
    }

    // this is disabled because it sometimes causes an infinite loop.
    // Skip for 'public' routes (as before) and for unauthenticated visitors on
    // a public-gallery route — they have no state to sync. A logged-in user on
    // a public-gallery route is still synced like any protected route.
    if (!isPublic && currentUser) {
      userStore.ensureStateInSync()
      const userId = currentUser.email || currentUser.uid
      console.debug(`auth-triggers: User logged in, setting user id for analytics ${userId}`)
      await FirebaseAnalytics.setUserId({
        userId,
      })
    }
  } catch (error) {
    console.error('auth-triggers: Error getting current user', error)
    return navigateTo('/start')
  }
})
